import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  statusS: ["True"],
  activeStorage: true,
  relationshipTypeS: [],
  clientTypeS: [],
  selectedNaicsS: "",
  selectedApplicationsS: [],
  expiry : 0,
  sort_cloumnS: "",
  sort_orderS: "",
  customerToClientS: false,
};

const filterStateSlice = createSlice({
  name: "filterState",
  initialState,
  reducers: {
    setStatusS(state, action) {
      state.statusS = action.payload;
    },
    setRelationshipTypeS(state, action) {
      state.relationshipTypeS = action.payload;
    },
    setClientTypeS(state, action) {
      state.clientTypeS = action.payload;
    },

    setSelectedNaicsS(state, action) {
      state.selectedNaicsS = action.payload;
    },
    setSelectedApplicationsS(state, action) {
      state.selectedApplicationsS = action.payload;
    },
    setCustomerToClientS(state, action) {
      state.customerToClientS = action.payload;
    },
    setExpiry(state, action) {
      state.expiry = action.payload;
    },
    setSelectedActiveStorage(state, action) {
      state.activeStorage = action.payload;
    },
    setSortColumn(state, action) {
      state.sort_cloumnS = action.payload;
    },
    setSortOrder(state, action) {
      state.sort_orderS = action.payload;
    },
  },
});

export const {
  setStatusS,
  setRelationshipTypeS,
  setClientTypeS,
  setSortColumn,
  setSortOrder,
  setSelectedNaicsS,
  setSelectedApplicationsS,
  setSelectedActiveStorage,
  setCustomerToClientS,
  setExpiry,
} = filterStateSlice.actions;

export default filterStateSlice.reducer;
